<template>
  <b-modal
    v-model="editorShown"
    centered
    size="md"
    no-close-on-backdrop
    header-bg-variant="primary"
    header-text-variant="white"
    header-class="bg-purple"
    class="todo-modal"
    hide-footer
  >
    <template v-slot:modal-header>
      <div
        class="w-100 d-flex flex-row justify-content-between align-items-center"
      >
        <h5 class="modal-title">{{ formTitle }}</h5>
      </div>
    </template>
    <b-row>
      <b-col class="form-container">
        <div>
          <div class="control-label">
            Assigned to <span class="text-danger">*</span>
          </div>
          <home-dropdown-selector
            v-model="asignedIds"
            theme="assigned"
            :options="userOptions"
            :width="367"
          />
          <span
            style="font-size: 13px;"
            class="text-danger control-label"
            v-if="formErrors.asignedIds.length > 0"
          >
            {{ formErrors.asignedIds.join(".") }}
          </span>
        </div>
        <div class="mt-2">
          <div class="control-label">
            Description <span class="text-danger">*</span>
          </div>
          <b-form-textarea
            v-model="description"
            class="description"
          ></b-form-textarea>
          <span
            style="font-size: 13px;"
            class="text-danger control-label"
            v-if="formErrors.description.length > 0"
          >
            {{ formErrors.description.join(".") }}
          </span>
        </div>

        <div class="actions">
          <div @click="$emit('onHidden')" class="button button-cancel">
            Cancel
          </div>
          <div class="ml-2 button button-save" @click="submitToDo">
            Save
          </div>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { formatUser } from "../../helpers/user";
import { validateRequired } from "../../helpers/validation";
import taskServer from "../../server/tasks";
import HomeDropdownSelector from "./HomeDropdownSelector.vue";

export default {
  name: "ToDoAddEditModal",
  components: { HomeDropdownSelector },
  props: ["toDoId", "options"],
  data() {
    return {
      users: this.options,
      asignedIds: [],
      description: null,
      formErrors: {
        asignedIds: [],
        description: []
      }
    };
  },
  async mounted() {
    this.users = this.options;
  },
  methods: {
    ...mapActions("layout", ["showAlertSuccess", "showAlertError"]),
    ...mapActions("client", ["fetchPlacesOfService"]),
    resetValues() {
      this.asignedIds = [];
      this.description = null;
    },
    validateToDoSubmit() {
      let withoutErrors = true;

      this.formErrors.asignedIds = [];
      if (this.asignedIds.length === 0) {
        this.formErrors.asignedIds.push("This field is required");
        withoutErrors = false;
      }

      this.formErrors.description = [];
      if (!validateRequired(this.description)) {
        this.formErrors.description.push("This field is required");
        withoutErrors = false;
      }

      return withoutErrors;
    },
    async submitToDo(modalEvent) {
      modalEvent.preventDefault();
      const result = this.validateToDoSubmit();
      if (result) {
        const formData = {
          description: this.description,
          assignedToUserIds: this.asignedIds.map(item => item.id)
        };
        if (this.toDoId) {
          try {
            await taskServer.update(this.toDoId, formData);
          } catch (error) {
            this.showAlertError({
              message: error.message
            });

            return;
          }
        } else {
          try {
            const response = await taskServer.create(formData);
            if (response.length > 0) {
              this.$emit("onModify");
              this.resetValues();
              this.editorShown = false;
              this.showAlertSuccess();
            }
          } catch (error) {
            this.showAlertError({
              message: error.message
            });

            return;
          }
        }
      }
    }
  },
  computed: {
    ...mapGetters("client", ["selectedLocation"]),
    formTitle() {
      if (this.toDoId) {
        return "Edit task";
      } else {
        return "New To Do item ";
      }
    },
    editorShown: {
      get() {
        return !!this.$attrs.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    },
    userOptions() {
      return this.users.map(user => {
        return { id: user.id, label: formatUser(user) };
      });
    }
  },
  watch: {
    options: {
      handler: function(val) {
        this.users = val;
      },
      immediate: true
    }
  }
};
</script>

<style scoped lang="scss">
.todo-modal {
  color: var(--white, #fff);
  font-family: Bahnschrift !important;
  font-size: 16px;
  font-style: normal;
  font-weight: 600;
  line-height: normal;
}

.control-label {
  color: #707070;
  font-family: Bahnschrift;
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  margin-bottom: 9px;
}

.form-container {
  margin: 24px 0 41px 50px;
}

.description {
  width: 367px;
  height: 164px;
}
.actions {
  margin-top: 25px;
  display: flex;
  width: 367px;
  justify-content: space-between;
}

.button {
  display: flex;
  width: 149px;
  height: 40px;
  align-items: center;
  flex-shrink: 0;
  border-radius: 5px;
  color: #fff;
  font-family: Bahnschrift;
  font-size: 16px !important;
  font-style: normal;
  font-weight: 400;
  line-height: normal;
  justify-content: center;
  cursor: pointer;

  &-cancel {
    background: #707070;
  }

  &-save {
    background: #363abb;
  }
}
</style>
